import { useSocketStore } from '../contexts/SocketStore'

export const updateSocketAccessToken = (accessToken) => {
  const socket = useSocketStore.getState().socket
  if (!socket || !accessToken) return

  socket.io.opts.query = {
    ...socket.io.opts.query,
    token: accessToken,
  }
}
